<div class="chart-container" [style.height.px]="this.chartHeight()">
  <canvas #chartCanvas></canvas>
</div>
